import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import { ReactComponent as BackArrow } from "../assets/icons/BackArrow.svg";
import { ReactComponent as Arrow } from "../assets/icons/Arrow.svg";
import InstructionFaceScan from "../assets/images/InstructionFaceScan.png";
import InstructionFingerScan from "../assets/images/InstructionFingerScan.png";

const ScanInstructions = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const scanType = state?.scanType;
  const scanDuration = state?.scanDuration || 60;

  const goToQuestionnaire = () => {
    navigate("/health-questionnaire", { state });
  };

  const faceInstructions = [
    { text: "Ensure you are in a well-lit area with steady, white light.", icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
    )},
    { text: "Remove your masks, eye-wear, or clothing obstructing the face for the duration of scan.", icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
    )},
    { text: "Keep your face and phone steady to avoid movements during the scan.", icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>
    )},
    { text: "For light mode: Make sure your face is mostly covered by the blue circle.", icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
    )},
    { text: "If prompted, allow the camera permission.", icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
    )},
  ];

  const fingerInstructions = [
    { text: "Place your finger on the rear primary camera and the flashlight.", icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11" /></svg>
    )},
    { text: "Make sure the screen looks bright red in color.", icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /></svg>
    )},
    { text: "If the flash is not turned on then place some light behind the phone.", icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
    )},
    { text: "If prompted, allow the camera permission.", icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
    )},
  ];

  const instructions = scanType === "face" ? faceInstructions : fingerInstructions;

  return scanType === "face" || scanType === "finger" ? (
    <section className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-[#1845a3] to-[#ED1C24] px-5 pt-5 pb-10">
        <div className="flex items-center">
          <Link className="flex-shrink-0 p-1 pr-3" to={-1}>
            <BackArrow className="h-2.5 w-2.5 text-white" />
          </Link>
          <h3 className="text-sm font-semibold text-white tracking-wide">Instructions</h3>
        </div>
      </div>

      <div className="px-5 -mt-6">
        <div className="rounded-2xl bg-white shadow-lg border border-gray-100 overflow-hidden">
          <div className="flex flex-col items-center py-6 px-4">
            <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#1845a3]/10 to-[#ED1C24]/10 flex items-center justify-center">
              <img
                className="h-14 w-14"
                src={scanType === "face" ? InstructionFaceScan : InstructionFingerScan}
                alt="instructions"
              />
            </div>
            <h3 className="mt-3 text-sm font-bold text-gray-800 capitalize">{scanType} Scan</h3>
            <p className="text-xxs text-gray-400 mt-0.5">
              Follow these steps for an accurate {scanDuration}-second scan
            </p>
          </div>

          <div className="px-4 pb-5 space-y-2.5">
            {instructions.map((item, index) => (
              <div key={index} className="flex items-start space-x-3 p-3 rounded-xl bg-gray-50 border border-gray-100">
                <div className="shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-[#1845a3] to-[#ED1C24] flex items-center justify-center text-white shadow-sm">
                  {item.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start space-x-2">
                    <span className="shrink-0 w-4 h-4 rounded-full bg-gradient-to-r from-[#1845a3] to-[#ED1C24] text-white text-xxs font-bold flex items-center justify-center mt-0.5">{index + 1}</span>
                    <p className="text-xxs text-gray-600 leading-relaxed">{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="px-4 pb-5">
            <button
              className="w-full flex items-center justify-center space-x-2 py-3 rounded-xl bg-gradient-to-r from-[#1845a3] to-[#ED1C24] text-white shadow-lg"
              type="button"
              onClick={goToQuestionnaire}
            >
              <span className="text-xs font-semibold">Proceed</span>
              <Arrow className="flex-shrink-0 h-3 w-3" />
            </button>
          </div>
        </div>

        <div className="mt-4 p-4 rounded-xl bg-gray-100 border border-gray-200">
          <h3 className="text-xxs font-semibold text-gray-500">Disclaimer</h3>
          <p className="mt-1.5 text-xxs text-gray-400 text-justify leading-relaxed">
            For Investigational Use Only. Careplix is not a substitute for the clinical judgment of a healthcare professional.
            Careplix is intended to improve your awareness of general wellness. Careplix does not diagnose, treat, mitigate or
            prevent any disease, symptom, disorder or abnormal physical state. Consult with a health care professional or
            emergency services if you believe you may have a medical issue.
          </p>
          <p className="mt-2 text-gray-400 text-left font-semibold leading-relaxed" style={{ fontSize: "0.55rem" }}>
            Indusindinsurance.com | 022 4890 3009 (Paid) | 74004 22200 (WhatsApp)
          </p>
          <p className="mt-1 text-gray-400 text-justify leading-relaxed" style={{ fontSize: "0.55rem" }}>
            T&C Apply. IRDAI Registration No. 103. IndusInd General Insurance Company Limited (Formerly known as Reliance General Insurance Company Limited). An ISO 9001:2015 Certified Company. Registered & Corporate Office: 6th Floor, Oberoi Commerz, International Business Park, Oberoi Garden City, Off. Western Express Highway, Goregaon (E), Mumbai-400063. Corporate Identity Number: U66603MH2000PLC128300.
          </p>
        </div>
      </div>
    </section>
  ) : (
    <Navigate to="/select-option" replace />
  );
};

export default ScanInstructions;
